import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import "./Titlebar.css";
// import Newmenu from './Newmenu';
import { TRANSPORTER_NAME } from "../config/config";
const screenfull = require("screenfull");

function Titlebar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);
  const [visible, setVisible] = useState(false);
  const history = useHistory();

  const getLocalFlag = () => {
    try {
      return localStorage.getItem("local_flag") === "true";
    } catch (e) {
      return false;
    }
  };
  const setLocalFlag = () => {
    try {
      localStorage.setItem("local_flag", JSON.stringify(!isLocal));
    } catch (e) {
      console.log("Errorr asdf", e.message);
    }

    setIsLocal(!isLocal);
  };
  const [isLocal, setIsLocal] = useState(getLocalFlag());
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  const displayMenu = () => {
    setVisible(true);
  };

  const hideMenu = () => {
    setVisible(false);
  };

  useEffect(() => {
    showButton();
  }, []);

  const token = sessionStorage.getItem("access_token");
  const isLoggedIn = token && token.trim() !== "" && token !== "null" && token !== "undefined";

  const goToBiltyInquiry = () => {
    history.push("/bilty-inquiry");
  };

  const goBackToLogin = () => {
    history.push("/");
  };

  window.addEventListener("resize", showButton);

  if (screenfull.isEnabled) {
    screenfull.on("change", () => {
      console.log("Am I fullscreen?", screenfull.isFullscreen ? "Yes" : "No");
    });
  }

  const toggleFullScreen = () => {
    if (screenfull.isEnabled) {
      screenfull.toggle();
    }
  };

  return (
    <>
      <nav className="titlebar">
        <div
          className="titlebar-container"
          onMouseLeave={hideMenu}
          onMouseOver={displayMenu}
        >
          <Link to="/" className="titlebar-logo" onClick={closeMobileMenu}>
            <div className="logo">{TRANSPORTER_NAME}</div>
            {/* <i className="fab fa-typo3" /> */}
          </Link>

          {/* <a
            className="log-out-container"
            href="https://www.gstsearch.in/verify.html "
          >
            GST
          </a> */}

          {/* <a
            className="log-out-container"
            href="https://download.anydesk.com/AnyDesk.exe"
          >
            Anydesk
          </a> */}
          {/* <button className="btn" onClick={setLocalFlag}>
            {isLocal ? "Local" : "Global"}
          </button> */}

          {process.env.REACT_APP_CLIENT === "bgtc" && !isLoggedIn && (
            location.pathname === "/bilty-inquiry" ? (
              <button
                className="btn btn-secondary"
                onClick={goBackToLogin}
                style={{ marginLeft: "10px" }}
              >
                Back to Login
              </button>
            ) : (
              <button
                className="btn btn-primary"
                onClick={goToBiltyInquiry}
                style={{ marginLeft: "10px" }}
              >
                Bilty Inquiry
              </button>
            )
          )}
          

          {/* <label className="log-out-container">DHRUMIL:9978961139</label> */}
          <label className="log-out-container">
                Logged in Year: {JSON.parse(sessionStorage.getItem("financial_year"))?.financial_year}
          </label>

          {/* <button className="log-out-container" onClick={toggleFullScreen}>
            Toggle Screen
          </button> */}

          {/* <Newmenu isVisible={visible} /> */}
        </div>
      </nav>
    </>
  );
}

export default Titlebar;

// import React, { useState, useEffect } from 'react';
// import { Button } from './Button';
// import { Link } from 'react-router-dom';
// import './Titlebar.css';
// import Newmenu  from "./Newmenu"

// function Titlebar() {
//   const [click, setClick] = useState(false);
//   const [button, setButton] = useState(true);

//   const handleClick = () => setClick(!click);
//   const closeMobileMenu = () => setClick(false);

//   const showButton = () => {
//     if (window.innerWidth <= 960) {
//       setButton(false);
//     } else {
//       setButton(true);
//     }
//   };

//   useEffect(() => {
//     showButton();
//   }, []);

//   window.addEventListener('resize', showButton);

//   const [visible, setVisible] = useState(false)

//   const displayMenu = () => {
//       setVisible(true)
//   }
//   const hideMenu = () => {
//       setVisible(false)
//   }

//   return (
//     <div className="block"
//         onMouseLeave={hideMenu}>
//         <Newmenu isVisible={visible} />
//     </div>
//   );
// }

// export default Titlebar;
